'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['', 'M144 80c-44.2 0-80 35.8-80 80l0 16-48 0 0-16C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 7.4c0 38.2-18.2 74.2-49 96.8l-71 52 0 11.8 0 24-48 0 0-24 0-24 0-12.2 9.8-7.2 80.8-59.2c18.5-13.6 29.4-35.1 29.4-58.1l0-7.4c0-44.2-35.8-80-80-80l-32 0zm48 336l0 64-64 0 0-64 64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;